// Pure lookup shared by DropzoneComponentController and SliderComponentController to find
// which <li> in a Splide-managed <ul> contains the element matching `selector` — the
// upload's `[data-uuid='...']` loader placeholder, or a thumbnail's `#js-preview-thumbnail-<id>`.
//
// Returns null — never a guessed index — when the element can't be located, so callers can
// degrade gracefully (skip the DOM op, or append instead of insert-at-position) instead of
// dereferencing null or falling back to index 0, which would silently mutate the wrong slide
// on a multi-attachment send.
//
// Extracted so unit tests exercise the same function both controllers call.
export function findPreviewListIndex(ulEl, selector) {
  const liEl = ulEl?.querySelector(selector)?.parentElement
  if (!liEl) return null

  const index = Array.prototype.indexOf.call(ulEl.querySelectorAll('li'), liEl)
  return index === -1 ? null : index
}
